<script>
import Layout from '@layout/main'
import { conditionList } from '@utils/is-condition'
import _findIndex from 'lodash/findIndex'
import { orderRegStatusItem } from '@utils/zerone-order'
import OrderSessionsList from '@components/List/OrderSessionsList'
import { authComputed } from '@store/helpers'


import DialogCancel from '@components/Dialog/CancelOrder'
import CancelOrderList from '../MemberEvent/components/CancelOrderList.vue'

export default {
  page() {
    return {
      title: `${this.orderItem.title} | 報名完成`,
    }
  },
  components: {
    Layout,
    OrderSessionsList,
    DialogCancel,
    CancelOrderList
  },
  props: {
    orderItem: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogVisibleQrCode: false,
      waitingBtn: true,
      page: 1,
      isDialogCancelVisible: false
    }
  },
  computed: {
    ...authComputed,
    stepList() {
      return conditionList([
        {
          title: '選取場次',
          value: 0,
          condition: () => {
            return this.orderItem.registrationType === 'partial'
          },
        },
        {
          title: '選取餐食',
          value: 1,
          condition: () => {
            return !!this.orderItem.meal[0]
          },
        },
        {
          title: '填寫資訊',
          value: 2,
        },
        {
          title: '報名完成',
          value: 3,
        },
      ])
    },
    activeStep() {
      const index = _findIndex(this.stepList, (item) => {
        return item.value === this.step
      })

      return index !== -1 ? index : this.step
    },
    statusItem() {
      return orderRegStatusItem(this.orderItem.regStatus)
    },
    // defaultValueImgClass() {
    //   if(!this.orderItem.bannerImage) {
    //     return 'isStyleWhite isDefaultBgEventItem isNotParallax'
    //   } else {
    //     return 'isNotParallax isStyleWhite'
    //   }
    // }
  },
  created() {
    const initStep = () => {
      this.step = this.stepList[this.stepList.length - 1].value
    }

    initStep()
  },
  methods: {
    takeLast(text, num = 5) {
      return text.substring(text.length - num, text.length)
    },
    goToMemberEvent() {
      if (this.orderItem?.orders[0]?.phoneNumber === this.currentMember.mobilePhone) {
        this.$router.push({
          name: this.orderItem.categoryTitle === '課程' ? 'member-event-item' : 'member-activity-item',
        })
      } else {
        this.$alert('目前登入的會員與參與人不符，請登入參與人會員查看此報名詳情', {
          customClass: 'isStyleBase',
          title: '會員不符合',
          confirmButtonText: '確定',
          showClose: false,
        })
      }
    },
    setPage() {
      const vm = this
      vm.page = 2
      this.$scrollToElement({
        $el: this.$refs['sectionList'],
        offset: 270,
      })
    },
    backPage() {
      const vm = this
      vm.page = 1
      this.$scrollToElement({
        $el: this.$refs['sectionList'],
        offset: 270,
      })
    },
  },
}
</script>
<template>
  <Layout>
    <BaseBanner :title="`${orderItem.title}`" type="event" :image="require('@assets/images/course/index_banner.png')" custom-class="isStyleWhite isDefaultBgEventItem isArticle" />
    <section :class="$style.sectionCoursesThankyou" class="section">
      <div class="container">
        <BaseStep v-model="activeStep" :list="stepList" class="mb-5" />
        <!--<div class="finish__top">
          <div class="finish__inner">
            <p class="finish__text"
            <template>
              <div class="qr-code">
                <img src="http://s05.calm9.com/qrcode/2021-05/9UHHGJ3AKN.png" alt="" />
                <span class="qr-code__text">憑證編號末五碼 : 13579</span>
                <BaseButton class="isStylePrimary isSmall isRadius isOutline2 isFull" @click="dialogVisibleQrCode = true"> 入場憑證使用說明 </BaseButton>
              </div>
            </template>
          </div>
        </div>-->
        <!--<template v-if="pageType !== 'single' && pageType !== 'single-isLive'">
          <div v-if="pageType === 'multiple-items'" class="finish__group">
            <div class="finish__group__title">2021年5月5日 (三）</div>
            <EventSession :event="courseList.first[2]" type="finish" @openDialog="openDialog"/>
          </div>
          <div v-if="pageType === 'multiple-items-isLive' && type !== 'member'" class="finish__group">
            <div class="finish__group__title">2021年5月5日 (三）</div>
            <EventSession :event="courseList.first[4]" :page-type="pageType" type="finish" @openDialog="openDialog"/>
          </div>
          <div v-if="type === 'member' && pageType === 'multiple-items-isLive'" class="finish__group">
            <div class="finish__group__title">2021年5月5日 (三）</div>
            <EventSession :event="courseList.first[4]" :page-type="pageType" type="member" @openDialog="openDialog"/>
          </div>
          <template v-if="pageType === 'multiple-day-items'">
            <div class="finish__group">
              <div class="finish__group__title">2021年5月6日 (四）</div>
              <EventSession :event="courseList.first[2]" type="finish" @openDialog="openDialog"/>
            </div>
            <div class="finish__group">
              <div class="finish__group__title">2021年5月7日 (五）</div>
              <EventSession :event="courseList.first[2]" type="finish" @openDialog="openDialog"/>
            </div>
          </template>
        </template>
        <div v-if="type === 'member' && pageType === 'single-isLive'" class="finish__group">
          <div class="finish__group__title">2021年5月7日 (五）</div>
          <EventSession :event="courseList.first[3]" :page-type="pageType" type="member" @openDialog="openDialog"/>
        </div>-->
        <div class="globalWhiteBox mb-5">
          <div class="text-center">
            <h2 class="text-2xl mb-4">報名完成</h2>
            <div class="text-sm md:text-base mb-4">
              報名狀態：
              <!-- 因為他們現在改人工審核，所以報名候補的人，在一開始只有“審核中”，
              他們某天成功候補的話，進到會員中心時，報名狀態：報名成功 -->
              <template v-if="orderItem.regStatus === 'WAITING'">
                <el-tag class="isStyleWarning"> 審核中 </el-tag>
              </template>
              <template v-else>
                <el-tag :class="statusItem.class">
                  {{ statusItem.title }}
                </el-tag>
              </template>
            </div>
            <template v-if="orderItem.regStatus === 'WAITING'">
              <div class="text-sm">
                <p>因目前報名已額滿，您的報名將列入候補。</p>
                <p>若有名額釋出，我們將最遲於活動前兩天通知您。</p>
                <p>謝謝。</p>
              </div>
            </template>
          </div>
          <hr />

          <template v-if="page === 1">
            <OrderSessionsList :online-type="orderItem.regStatus === 'CONFIRMED' && orderItem.type === 'online'" :order-item="orderItem" :waiting-btn="waitingBtn" />
          </template>
          <template v-else-if="page === 2">
            <CancelOrderList :order-item="orderItem" :detail="'detail'" @back="backPage" />
          </template>

          <template v-if="orderItem.type === 'physical' && orderItem.qrcode && orderItem.regStatus === 'CONFIRMED'">
            <hr />
            <div class="text-center">
              <img alt="qrcode" :src="`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${orderItem.qrcode}&chld=L|0`" class="mb-2" />
              <div class="text-sm md:text-base text-center"> 憑證編號末五碼 : {{ takeLast(orderItem.qrcode, 5) }} </div>
              <BaseButton class="isStylePrimary isSmall isRadius isOutline2 isFull mt-3" @click="dialogVisibleQrCode = true"> 入場憑證使用說明 </BaseButton>
            </div>
          </template>
        </div>
        <!--<BaseButton
          class="isStylePrimary isOutline2 isFull mb-4 isRadius"
        >
          加入行事曆
        </BaseButton>-->


        <template v-if="page === 1">

          <BaseButton v-if="true && orderItem.regStatus !== 'CANCELED' && orderItem.registrationType === 'impartial'"
          class="isStylePrimary isOutline2 isFull isRadius mb-4"
          @click="isDialogCancelVisible = true">
            取消場次報名
          </BaseButton>
          <BaseButton v-if="true && orderItem.regStatus !== 'CANCELED' && orderItem.registrationType === 'partial'" class="isStylePrimary isOutline2 isFull isRadius mb-4" @click="setPage">
            取消場次報名
          </BaseButton>

          <BaseButton class="isStylePrimary isFull isRadius mb-3" @click="goToMemberEvent"> 查看報名詳情 </BaseButton>
          <BaseButton class="isStylePrimary isOutline2 isFull isRadius" :to="{ name: 'brand-event-item' }"> 查看活動資訊 </BaseButton>

        </template>


        <!--<DialogSession
          :list="courseList.first[2]"
          :dialog-index="0"
          :visible.sync="isDialogSessionVisible"
        />-->

        <el-dialog class="IsNotice" :visible.sync="dialogVisibleQrCode" width="1332px">
          <template v-slot:title> 入場憑證使用說明 </template>
          <div :class="$style.notice">
            <h4 class="notice__title">如何進場？</h4>
            <ol class="notice__list">
              <li class="notice__item">請於現場出示下方QR Code憑證入場，無論使用手機、平板或列印，皆可順利報到。</li>
            </ol>
            <h4 class="notice__title">電子憑證使用須知</h4>
            <ol class="notice__list">
              <li class="notice__item">以下QR Code即為您參加活動的電子票券，每張票券僅限該場活動使用，恕無法持其他任何憑證要求入場。 </li>
              <li class="notice__item">零壹科技保留票券使用最終解釋權</li>
            </ol>
          </div>
        </el-dialog>
        <!--<finish :course-list="courseList" :page-type="pageType "/>-->
        <BasePre>{{ orderItem }}</BasePre>
      </div>
    </section>

    <DialogCancel :order-item="orderItem" :visible.sync="isDialogCancelVisible"></DialogCancel>

  </Layout>
</template>
<style lang="scss" module>
.sectionCoursesThankyou {
  background-color: $color-gray-2;
  @include max-md {
    padding-bottom: 3rem;
  }
  :global {
    .sectionCoursesThankyou {
    }
  }
}

.notice {
  :global {
    .notice {
      &__title {
        margin-bottom: 1.5rem;
        font-size: 1.125em;
        color: $color-primary;
      }

      &__list {
        padding-left: 2rem;
        margin-bottom: 3rem;
      }

      &__item {
        margin-bottom: 0.6rem;
      }
    }
  }
}

.finishWrapper {
  :global {
    .finishWrapper {
      &__Btn {
        padding-right: 3rem;
        padding-left: 3rem;

        @include max-md {
          padding-right: 1rem;
          padding-left: 1rem;
        }
      }
    }
  }
}

.finish {
  padding-top: 4.375rem;
  padding-bottom: 3rem;
  margin-bottom: 6.25rem;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(33, 69, 88, 0.16);

  @include max-md {
    padding-right: 1rem;
    padding-left: 1rem;
    margin-bottom: 3.25rem;
  }

  :global {
    .qr-code {
      max-width: 350px;
      margin-right: auto;
      margin-bottom: 3.75rem;
      margin-left: auto;
      text-align: center;

      &__text {
        display: block;
        margin-bottom: 3.75rem;
        font-size: 0.875em;
      }
    }

    .finish {
      &__state {
        margin-bottom: 1.875em;
        text-align: center;
      }

      &__top {
        padding-bottom: 1rem;
        border-bottom: $color-gray-3 1px solid;
      }

      &__inner {
        max-width: 776px;
        margin-right: auto;
        margin-left: auto;
      }

      &__title {
        margin-bottom: 2rem;
        font-size: 1.5rem;
        text-align: center;
      }

      &__text {
        margin-bottom: 2rem;
        line-height: 1.8;
        color: $color-gray-6;
      }

      &__group {
        padding-top: 3.75rem;

        &__title {
          padding-left: 3rem;
          margin-bottom: 2rem;
          font-size: 1.5rem;
          font-weight: 500;
          color: $color-primary;

          @include max-md {
            padding-left: 0;
            text-align: center;
          }
        }
      }
    }
  }

  &:global {
    &.isSingle {
      max-width: 876px;
      margin-right: auto;
      margin-left: auto;

      .finish__top {
        border: 0;
      }
    }
  }
}
</style>
